import React, {
    useState,
    useEffect
}
from "react";

import {
    useHistory
}
from "react-router-dom";

import {
    functions
}
from "../../../constants/common-functions";

import HomeBox
from "../components/HomeBox";

import {
    OMNISCAN_BLUE,
    OMNISCAN_BLUE_RGB
}
from "../../../constants/colors";


export default function HomeBoxSpace({

    homeConfig,
    isMobile

})
{

    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [isLive, setIsLive] =
        useState(false);

    const [kpiSqft, setKpiSqft] =
        useState(0);

    const [kpiHhc, setKpiHhc] =
        useState(0);

    const [kpiSqftHhc, setKpiSqftHhc] =
        useState(0);


    //--------------------------------------------------------
    // Router
    //--------------------------------------------------------

    const history =
        useHistory();


    //--------------------------------------------------------
    // Load configuration
    //--------------------------------------------------------

    useEffect(

        () =>
        {
            if(homeConfig)
            {
                setIsLive(
                    homeConfig.isLiveLinkSpace
                );

                setKpiSqft(
                    homeConfig.kpiSqft
                );

                setKpiHhc(
                    homeConfig.kpiHhc
                );

                setKpiSqftHhc(
                    homeConfig.kpiSqfthhc
                );
            }
        },

        [homeConfig]

    );


    //--------------------------------------------------------
    // Navigation
    //--------------------------------------------------------

    const goSpace =
        () =>
        {
            history.push(
                "/spaceorgdashboard"
            );
        };


    //--------------------------------------------------------
    // KPI colours
    //--------------------------------------------------------

    const figureColours =
    [
        "#e99422",
        "#7447e8",
        "#d33b12"
    ];


    //--------------------------------------------------------
    // Main container
    //--------------------------------------------------------

    const thisContainer =
    {
        display:
            "flex",

        width:
            "100%",

        justifyContent:
            "space-between",

        alignItems:
            "stretch",

        padding:
            isMobile
                ?
                "8px"
                :
                "8px 10px",

        gap:
            "10px",

        boxSizing:
            "border-box"
    };


    //--------------------------------------------------------
    // KPI tile
    //--------------------------------------------------------

    const metricBox =
    {
        display:
            "flex",

        flex:
            1,

        minWidth:
            0,

        flexDirection:
            "column",

        background:
            "rgba(248,250,252,0.88)",

        border:
            "1px solid rgba(12,53,88,0.10)",

        borderRadius:
            "0px",

        overflow:
            "hidden"
    };


    //--------------------------------------------------------
    // KPI label
    //--------------------------------------------------------

    const metricTitle =
    {
        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        height:
            "32px",

        color:
            "#465566",

        fontSize:
            "13px",

        fontWeight:
            500,

        letterSpacing:
            "0.15px",

        borderBottom:
            "1px solid rgba(12,53,88,0.08)"
    };


    //--------------------------------------------------------
    // KPI figure
    //--------------------------------------------------------

    const metricFigure =
    {
        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        height:
            "30px",

        color:
            "#ffffff",

        fontSize:
            "16px",

        fontWeight:
            700,

        letterSpacing:
            "0.2px"
    };


    //--------------------------------------------------------
    // Click
    //--------------------------------------------------------

    const clickFunction =
        () =>
        {
            goSpace();
        };


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <HomeBox

            isMobile={isMobile}
            isLive={isLive}
            title="Space"
            color={OMNISCAN_BLUE}
            colorRgb={OMNISCAN_BLUE_RGB}
            clickFunction={clickFunction}
            icon="city"
            delay={720}

        >

            <div style={thisContainer}>


                {/* ------------------------------------------
                    SQUARE FEET
                ------------------------------------------- */}

                <div style={metricBox}>

                    <div style={metricTitle}>

                        Sq Ft

                    </div>

                    <div
                        style={{
                            ...metricFigure,
                            background:
                                figureColours[0]
                        }}
                    >

                        {
                            functions.formatNumber(
                                kpiSqft,
                                0
                            )
                        }

                    </div>

                </div>


                {/* ------------------------------------------
                    HHC
                ------------------------------------------- */}

                <div style={metricBox}>

                    <div style={metricTitle}>

                        HHC

                    </div>

                    <div
                        style={{
                            ...metricFigure,
                            background:
                                figureColours[1]
                        }}
                    >

                        {
                            functions.formatNumber(
                                kpiHhc,
                                0
                            )
                        }

                    </div>

                </div>


                {/* ------------------------------------------
                    SQ FT / HHC
                ------------------------------------------- */}

                <div style={metricBox}>

                    <div style={metricTitle}>

                        Sq Ft/HHC

                    </div>

                    <div
                        style={{
                            ...metricFigure,
                            background:
                                figureColours[2]
                        }}
                    >

                        {
                            functions.formatNumber(
                                kpiSqftHhc,
                                0
                            )
                        }

                    </div>

                </div>

            </div>

        </HomeBox>

    );

}